import {
  PracticeSetupStepCategory,
  PracticeSetupStepId,
} from '@principle-theorem/principle-core/interfaces';
import { map } from 'rxjs/operators';
import { PracticeSetupStepValidation } from './practice-setup-step-validation';
import {
  IPageVisitTrackingConfig,
  IPracticeSetupStepDefinition,
} from './practice-setup-step.types';
import { initRawSchema } from '@principle-theorem/editor';

const pageVisitTracking: IPageVisitTrackingConfig = {
  routes: ['settings/brand/{brandId}/referral-sources'],
  validationMode: 'any',
};

export const referralSourcesStep: IPracticeSetupStepDefinition = {
  id: PracticeSetupStepId.ReferralSources,
  category: PracticeSetupStepCategory.Miscellaneous,
  title: 'Set Up Referral Sources',
  description: initRawSchema(
    `By tracking your practice's referral sources, you can make informed decisions about investing in various marketing channels and identify which sources are most effective in bringing new patients to your practice. Referral sources tracked in your current PMS can be mapped to those set up in Principle during migration.`
  ),
  dependsOn: [],
  getRoute: (brand, _practice) =>
    `settings/brand/${brand.ref.id}/referral-sources`,
  validate$: (practice$, step, options) => {
    return practice$.pipe(
      map((_practice) => {
        if (options?.reviewed || options?.skipped) {
          return { valid: true };
        }

        const pageVisitValidation =
          PracticeSetupStepValidation.validatePageVisits(
            step,
            pageVisitTracking
          );
        if (pageVisitValidation.valid) {
          return { valid: true };
        }

        return {
          valid: false,
          reason:
            'Please review and approve all referral sources before completing this step',
        };
      })
    );
  },
  pageVisitTracking,
};
